@if (actions().length) {
    @for (action of inlineActions(); track action.id) {
        <button
            type="button"
            libAncButton
            variant="tertiary"
            size="small"
            [disabled]="action.disabled"
            (click)="onItem(action)"
        >
            @if (action.icon) {
                <i class="icon" [ngClass]="action.icon"></i>
            }
            <span translate>{{ inlineLabel(action) }}</span>
        </button>
    }
    @if (showAsDropdown()) {
        <div
            ngbDropdown
            class="d-inline-block common-dropdown-outer pdp-header__dropdown anc-action-dropdown"
            container="body"
            placement="bottom-end"
            [popperOptions]="popperOptions"
        >
            <button
                type="button"
                libAncButton
                variant="tertiary"
                size="small"
                ngbDropdownToggle
                class="pdp-header__more"
                [attr.aria-label]="'More actions' | translate"
            >
                <i class="icon icon--24 icon-more-horizontal" aria-hidden="true"></i>
            </button>
            <div ngbDropdownMenu class="dropdown-menu anc-action-menu">
                @for (action of menuActions(); track action.id) {
                    <button
                        type="button"
                        class="dropdown-item"
                        [class.text-danger]="action.danger"
                        [disabled]="action.disabled"
                        (click)="onItem(action)"
                    >
                        @if (action.icon) {
                            <span
                                class="icon"
                                [ngClass]="action.icon"
                                aria-hidden="true"
                            ></span>
                        }
                        <span translate>{{ action.label }}</span>
                    </button>
                }
            </div>
        </div>
    }
}
